import type { GraphPathLookupParameters } from '../api/GraphPathLookupParameters';
import type { GraphTopologyParameters } from '../api/GraphTopologyParameters';
import type { GraphUrlResponseBody } from '../api/GraphUrl';
import type { PathLookupGraphSettings } from '../graphSettings/PathLookupGraphPreset';
import type { TopologyGraphSettings } from '../graphSettings/TopologyGraphPreset';
import type { PathLookupType } from '../pathLookup/PathLookupChecks';
import type { GraphSidePanelContentId } from './GraphSidePanelContentId';

export interface GraphSharedViewParameters {
  viewUrlId: string;
  viewUrlData?: GraphUrlResponseBody;
  type: 'sharedView';
}

export interface GraphLinkArgs<TGraphParameters> {
  parameters?: TGraphParameters;
  sidePanelContentId?: GraphSidePanelContentId;
  settings?: TopologyGraphSettings | PathLookupGraphSettings;
  pathLookupDataInputTabId?: PathLookupType;
}

export type GraphInitialParameters =
  | GraphTopologyParameters
  | GraphPathLookupParameters
  | GraphSharedViewParameters;

export const isGraphSharedViewParameters = (
  params?: GraphInitialParameters | null,
): params is GraphSharedViewParameters =>
  !!params && Object.prototype.hasOwnProperty.call(params, 'viewUrlId');

export const isTopologyInitialParameters = (
  params?: GraphInitialParameters | null,
): params is GraphTopologyParameters => params?.type === 'topology';

export const isPathlookupInitialParameters = (
  params?: GraphInitialParameters | null,
): params is GraphPathLookupParameters => params?.type === 'pathLookup';
